import '../style/cardStyle.css';
import { useDispatch, useSelector } from 'react-redux';
import CardCom from '../components/Card';
import {TextField, Typography } from '@mui/material';
import Progress from '../components/prograssBar';
import { Helmet } from 'react-helmet-async';
import { setRepeatForAllW } from '../store/reducers/werdAlthekrSlice';


export default function WerdAlthekr() {
    const value = useSelector((state) => state.werdAlthekr.value);
    const card = useSelector((state) => state.werdAlthekr.data); // Ensure this is the correct slice of state
    const dispatch = useDispatch();

    const handleChangeRepeat = (e) => {
        dispatch(setRepeatForAllW(e.target.value));
    };
    return (
        <>
            <Helmet>
                <title>ورد ذكر الله</title>
                <meta name='description' content='ورد ذكر الله' />
                <link rel="canonical" href="/werdAlthekr" />
            </Helmet>
            <div className='mainScreen'>
                <Progress value={value} />
                <Typography variant="h3" component="p" className='title' sx={{ color: "text.primary" }}>ورد ذكر الله</Typography>
                   <div className="repeat-input-wrapper">
  <TextField
    type="number"
    label="عدد التكرار"
    variant="outlined"
    size="large"
    onChange={handleChangeRepeat}
    className="repeat-input"
  />
</div>
                <CardCom card={card} type={'werdAlthekr'} />
            </div>

        </>
    );
}